import type { BaseParams } from "../../../../client.types.js";
import type { PrepareGeneratedInvoiceResponse200 } from "../../../../routes/private/Ambassadors/Wallets/PrepareGeneratedInvoice/PrepareGeneratedInvoice.interfaces.js";
import { createAxiosRoute } from "../../../../utils/createAxiosRoute.js";

export type { PrepareGeneratedInvoiceResponse200 };

export const prepareGeneratedInvoice = (p: BaseParams) =>
    createAxiosRoute<void, PrepareGeneratedInvoiceResponse200>({
        ...p,
        method: "get",
        path: "/api/ambassadors/wallets/prepareGeneratedInvoice",
    });
